'use client';

import { useApi } from '@prismo-io/core';
import { JsonSchema, type JsonSchemaT } from '@prismo-io/schemas';
import type { SWRArgs } from '@prismo-io/schemas';
import { useRouter } from 'next/navigation';
import useSWRMutation from 'swr/mutation';

export const useSetOrganizationMetadata = () => {
  const { client } = useApi();

  const router = useRouter();

  return useSWRMutation(
    'set-organization-metadata',
    async (key, { arg }: SWRArgs<JsonSchemaT>) => {
      const metadata = JsonSchema.parse(arg);

      if (typeof metadata !== 'object') {
        throw new Error('Metadata must be an object.');
      }

      const {
        data: { session },
      } = await client.auth.getSession();

      if (!session) {
        throw new Error('You must be connected.');
      }

      const { data: user } = await client
        .from('users')
        .select('organization_form_metadata')
        .eq('id', session.user.id)
        .maybeSingle();

      if (!user) {
        throw new Error('You must be connected.');
      }

      const previousMetadata = JsonSchema.parse(
        user.organization_form_metadata
      );

      if (typeof previousMetadata !== 'object') {
        throw new Error('Previous Metadata must be an object.');
      }

      await client
        .from('users')
        .update({
          organization_form_metadata: {
            ...previousMetadata,
            ...metadata,
          },
        })
        .eq('id', session.user.id);

      router.refresh();

      return true;
    }
  );
};
